module.exports = new __parcel__URL__("discount.bf9ea60d.png").toString();